import cn from 'classnames/bind';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

import { VolumeMuted } from '../../assets/VolumeMuted';
import { Fullscreen } from '../../assets/Fullscreen';
import { VolumeUnmuted } from '../../assets/VolumeUnmuted';

import { PlayerControlsProps } from './PlayerControls.types';
import { PlayerControlButton } from './parts/PlayerControlButton';
import styles from './PlayerControls.module.css';
import { PlayerControlButtonSize } from './parts/PlayerControlButton.types';

const cx = cn.bind(styles);

export const PlayerControls: FunctionComponent<PlayerControlsProps> = (props) => {
    const {
        isMuted,
        className,
        buttonSize = PlayerControlButtonSize.XL,
        withFullscreenButton = true,
        onMuteClick,
        onFullscreenClick,
    } = props;
    const intl = useIntl();

    return (
        <div className={cx('root', className)}>
            <PlayerControlButton onClick={onMuteClick} size={buttonSize}>
                {isMuted ? (
                    <VolumeMuted
                        className={cx('volumeIcon')}
                        aria-label={intl.formatMessage({
                            id: 'components.PlayerControls.848b17ca26178e8baeffc6fd69068cfb',
                            defaultMessage: 'Turn on sound',
                            description: 'Лейбл кнопки включения звука',
                        })}
                    />
                ) : (
                    <VolumeUnmuted
                        className={cx('volumeIcon')}
                        aria-label={intl.formatMessage({
                            id: 'components.PlayerControls.eab5924313a44bcaa4f92de668c21ab1',
                            defaultMessage: 'Turn off sound',
                            description: 'Лейбл кнопки выключения звука',
                        })}
                    />
                )}
            </PlayerControlButton>
            {withFullscreenButton && (
                <PlayerControlButton onClick={onFullscreenClick} size={buttonSize}>
                    <Fullscreen
                        aria-label={intl.formatMessage({
                            id: 'components.PlayerControls.f46975143e86a3ba3c7abe185a05d19b',
                            defaultMessage: 'Full-screen',
                            description: 'Лейбл кнопки включения полноэкранного режима',
                        })}
                    />
                </PlayerControlButton>
            )}
        </div>
    );
};
